import React, { useState } from 'react';
import Loader from '../loader';
import Icon from '../../icon';
import useVideoStyles from './styles';
import { useTheme } from '../../theme/theming';
import NextImageRenderer from '../nextImageRenderer';

function VideoPlayer(props) {
  const { videoUrl, imageUrl, onlyThumbnail } = props;
  const [isEnabled, setIsEnableed] = useState(!imageUrl);
  const [isLoaded, setIsLoaded] = useState(!imageUrl);
  const classes = useVideoStyles({
    isLoaded,
    imageUrl: imageUrl
  });
  const theme = useTheme();

  function getId(url) {
    var regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url?.match(regExp);

    if (match?.[2].length == 11) {
      return 'https://www.youtube.com/embed/' + match[2];
    } else {
      return url;
    }
  }

  return (
    <>
      {!isLoaded && (
        <div
          className={classes.imgContainer}
          onClick={() => {
            if (onlyThumbnail) return;
            setIsEnableed(true);
          }}
        >
          <NextImageRenderer
            src={imageUrl}
            sectionIndex={props?.sectionIndex}
            className={classes.videoPlayerImage}
          />

          {isEnabled ? (
            <Loader />
          ) : (
            <>
              {props.onlyThumbnail ? null : (
                <Icon
                  name="Video Play"
                  color={theme.palette.font.invertedDefault}
                  className={classes?.icon}
                  onClick={() => {
                    setIsEnableed(true);
                  }}
                />
              )}
            </>
          )}
        </div>
      )}

      {isEnabled && (
        <iframe
          className={classes.iframe + ' ' + classes.hideImg}
          src={imageUrl ? getId(videoUrl) + '?autoplay=1' : getId(videoUrl)}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          onLoad={() => {
            setIsLoaded(true);
          }}
        />
      )}
    </>
  );
}

export default VideoPlayer;
